import { syncAction } from '@/lib/action';
import { BankFeedUserPermissionsRecord } from '@/domain/bankFeed/types';
import { BankFeedConnectionsHandleWebsocketPayload } from '@/domain/bankFeed/actions.types';
import type {
  BankFeedTransactionExportEventMetadata,
  BankFeedConnectionSetupCompletedMetadata,
} from '@/domain/bankFeed/schemas';

export const setUserPermissionsAction = syncAction<BankFeedUserPermissionsRecord>('BANK_FEED/SET_USER_PERMISSIONS');

export const bankFeedConnectionsHandleWebSocketAction = syncAction<BankFeedConnectionsHandleWebsocketPayload>(
  'BANK_FEED/CONNECTIONS_HANDLE_WEBSOCKET',
);

export const bankFeedTransactionExportCompletedAction = syncAction<BankFeedTransactionExportEventMetadata>(
  'BANK_FEED/TRANSACTION_EXPORT_COMPLETED',
);

export const bankFeedConnectionSetupCompletedAction = syncAction<BankFeedConnectionSetupCompletedMetadata>(
  'BANK_FEED/CONNECTION_SETUP_COMPLETED',
);
